import styled from 'styled-components';

export const StyledCard = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.on[100]};
  border-radius: ${({ theme }) => theme.radii.xl}px;
  padding: ${({ theme }) => theme.spacing(4)}px;
  background-color: ${({ theme }) => theme.colors.surface[0]};
  width: calc(100% - ${({ theme }) => theme.spacing(8)}px);
  text-align: left;
`;
